import { Button, Grid2, Typography } from '@mui/material';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { defineMessages, useIntl } from 'react-intl';

import ContentLoader from '@components/ContentLoader';
import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';
import DeactivateModalContent from '@components/Modal/Content/DisableEnableUserModalContent/DisableEnableUserContent';

import { useGetUserSettings } from '@hooks/api/session';
import { useGetUser } from '@hooks/api/user';
import { useModal } from '@hooks/useModal';

import { formatName } from '@utils/format';

const messages = defineMessages({
  text: {
    id: 'userDeactivation.text',
    defaultMessage: 'Deactivate your profile',
  },
  disable: {
    id: 'userDeactivation.disable',
    defaultMessage: 'Request Deactivation',
  },
});

const DeactivationSection: React.FC<{ id: string }> = ({
  id: user_id = '',
}) => {
  const { formatMessage } = useIntl();
  const { closeModal, openModal, setContent } = useModal();

  const { data: userData, loading: userDataLoading } = useGetUser({
    id: user_id,
  });
  const { data: userSettingsData, loading: userSettingsLoading } =
    useGetUserSettings({
      user_id,
    });
  const user = userData?.getUserRecord;
  const isDisabled = userSettingsData?.disabled;

  const loading = userDataLoading || userSettingsLoading;

  const handleOpenModal = () => {
    openModal({
      width: 800,
      props: {
        height: '300px',
      },
      children: null,
    });

    setContent({
      children: (
        <DeactivateModalContent
          disabled={false}
          email={user?.email}
          onSubmit={closeModal}
        />
      ),
    });
  };

  // User cannot request deactivation if they already are
  if (isDisabled) {
    return null;
  }

  return (
    <Grid2
      container
      alignItems="center"
      justifyContent="space-between"
      rowGap={1}
    >
      <ContentLoader loading={loading}>
        <Grid2>
          <Typography>
            {formatMessage(messages.text, {
              name: formatName(user?.first_name, user?.last_name),
            })}
          </Typography>
        </Grid2>
        <Grid2>
          <Button color="secondary" onClick={handleOpenModal}>
            <Typography variant="subtitle2">
              {formatMessage(messages.disable)}
            </Typography>
          </Button>
        </Grid2>
      </ContentLoader>
    </Grid2>
  );
};

export default withErrorBoundary(DeactivationSection, {
  FallbackComponent: ErrorBoundaryFallback,
});
